import { gql } from 'graphql-request';

import { MembershipOfferings } from '../types';
import { axiosQuery } from '../utils/axiosQuery';

const MEMBERSHIP_OFFERINGS_QUERY = gql`
  query MembershipOfferings {
    membershipOffering {
      membershipStatus {
        type
        subscriptionFound
      }
      channel
      entitlement {
        type
      }
      prepaidMonths
      eligibleForPartnership
      customerId
      customerName
    }
  }
`;

interface MembershipOfferingsResponse {
  membershipOffering: MembershipOfferings;
}

export const membershipOfferings = () =>
  axiosQuery<MembershipOfferingsResponse>('MembershipOfferings', MEMBERSHIP_OFFERINGS_QUERY);
